/**
 * Created by mac on 12/23/20
 */

const Shine = function (unit) {
    UnitComponent.call(this, unit);
};

Shine.prototype = Object.create(UnitComponent.prototype);
Shine.prototype.constructor = Shine;